"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingDepositStatus = void 0;
var StakingDepositStatus;
(function (StakingDepositStatus) {
    StakingDepositStatus["ACTIVE"] = "ACTIVE";
    StakingDepositStatus["CANCELED"] = "CANCELED";
    StakingDepositStatus["COMPLETE"] = "COMPLETE";
})(StakingDepositStatus || (exports.StakingDepositStatus = StakingDepositStatus = {}));
//# sourceMappingURL=deposit.js.map